<template>
  <div id="jcom-business-category-create">
    <v-overlay :value="LoadingFlag">
      <div class="d-flex justify-content-center align-items-center">
        <b-spinner variant="primary" type="grow" label="Loading..."></b-spinner>
      </div>
    </v-overlay>

    <!-- Premium Page Header -->
    <v-card elevation="20" class="header-card mb-6 overflow-hidden">
      <div class="header-backdrop-effect"></div>
      <v-container class="header-container py-0">
        <v-row align="center" class="py-6">
          <v-col cols="auto" class="flex-shrink-1">
            <div class="header-icon-box">
              <v-icon size="48" color="white">mdi-account-multiple-plus</v-icon>
            </div>
          </v-col>
          <v-col cols="auto" class="flex-grow-0">
            <h1 class="header-title">{{ PageTitle }}</h1>
            <p class="header-subtitle">{{ PageDescription }}</p>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="auto" class="flex-shrink-1">
            <v-btn
              icon
              color="white"
              @click="closePrompt"
              class="action-icon-btn"
              elevation="0"
            >
              <v-icon size="28">mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-card-text class="page-content">
      <v-container>
        <v-form
          ref="form1"
          v-model="valid1"
          lazy-validation
          v-on:submit.prevent="submitForm"
        >
          <v-container>
            <v-row wrap>
              <v-col cols="12" md="12">
                <p>
                  <span class="text-danger">*</span> indicates required field
                </p>
              </v-col>
              <v-col cols="12" sm="6" lg="4" md="4">
                <label>
                  <h6><span class="text-danger">*</span> Category Name</h6>
                </label>
                <v-text-field
                  v-model="CategoryName"
                  :rules="CategoryNameRules"
                  placeholder="Enter Category Name"
                  hint="This is the category name"
                  required
                  outlined
                  dense
                  prepend-inner-icon="mdi-label"
                  class="form-field"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" lg="4" md="4">
                <label>
                  <h6><span class="text-danger">*</span> Status</h6>
                </label>
                <v-switch
                  v-model="Status"
                  :label="Status ? 'Active' : 'Inactive'"
                  inset
                  color="success"
                ></v-switch>
              </v-col>
            </v-row>
            <v-row wrap>
              <v-col align="center" cols="12" md="12">
                <v-btn
                  :disabled="!valid1"
                  @click.prevent="submitForm"
                  :loading="SubmitFlag"
                  elevation="0"
                  shaped
                  x-large
                  color="success"
                  class="submit-btn"
                >
                  <v-icon left>mdi-check-circle</v-icon>
                  Submit
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-container>
    </v-card-text>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  props: {
    AddRecordPrompt: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      valid1: true,
      LoadingFlag: false,
      SubmitFlag: false,

      CategoryName: "",
      CategoryNameRules: [(v) => !!v || "Category is required"],

      Status: true,

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      CurrentYearId: 0,
      JciYearCode: "",
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
    };
  },
  computed: {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;
        this.CurrentYearId = CurrentJciYearId;
      }
    },
  },
  mounted() {},
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "jcom_business_category",
        Action: "create",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hideDialog");
    },
    submitForm() {
      console.log("submitForm is called");

      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);

      if (validate1) {
        var upload = {
          UserInterface: 1,
          Status: this.Status ? 1 : 0,
          CategoryName: this.CategoryName,
        };
        console.log({ upload });

        this.progessStart = 1;
        this.SubmitFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/jcom/business-category/store";
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.SubmitFlag = false;
            thisIns.progessStart = 0;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);

            if (flag == 1) {
              thisIns.sweetAlert("success", output, true);
              thisIns.closePrompt();
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.progessStart = 0;
            thisIns.SubmitFlag = false;
          });
      } else {
        var message = "";
        if (!validate1) {
          message += "Kindly fill the required fields";
        }
        this.sweetAlert("error", message, false);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>
<style lang="scss">
// Color Palette
$navy: #3a67b1;
$aqua: #0097d7;
$gold: #edbe38;
$seaform: #56bda3;
$text-90-black: #414042;
$text-off-black: #0a0f29;
$text-white: #ffffff;
$success-color: #1db954;
$danger-color: #e74c3c;
$info-color: $aqua;
$bg-light: #f8fafc;
$border-color: #e2e8f0;

// Animations
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-12px);
  }
}

@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

#jcom-business-category-create {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
  padding: 30px 15px;

  // ============================================
  // HEADER CARD
  // ============================================
  .header-card {
    background: linear-gradient(135deg, $navy 0%, $aqua 100%) !important;
    border-radius: 20px;
    overflow: hidden;
    animation: slideDown 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
    position: relative;
    border: none;
    box-shadow: 0 20px 60px rgba(58, 103, 177, 0.5), 0 0 20px rgba(0, 151, 215, 0.3);

    &::before {
      content: '';
      position: absolute;
      top: -50%;
      right: -20%;
      width: 400px;
      height: 400px;
      background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
      border-radius: 50%;
      animation: float 8s ease-in-out infinite;
    }

    .header-backdrop-effect {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120"><path d="M0,50 Q300,10 600,50 T1200,50 L1200,120 L0,120 Z" fill="rgba(255,255,255,0.05)"/></svg>') no-repeat bottom;
      background-size: cover;
      pointer-events: none;
    }
  }

  .header-container {
    padding: 20px 30px !important;
    position: relative;
    z-index: 1;
  }

  .header-icon-box {
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.25) 0%, rgba(255, 255, 255, 0.1) 100%);
    backdrop-filter: blur(15px);
    border-radius: 18px;
    padding: 14px;
    margin-right: 24px;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.4);
    animation: float 4s ease-in-out infinite;
    border: 2px solid rgba(255, 255, 255, 0.3);
  }

  .header-title {
    font-size: 36px;
    font-weight: 900;
    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3), 0 0 20px rgba(0, 151, 215, 0.3);
    animation: slideDown 0.8s ease-out;
    letter-spacing: 0.8px;
    color: $text-white;
    margin: 0;
  }

  .header-subtitle {
    font-size: 16px;
    opacity: 0.98;
    animation: slideDown 1s ease-out 0.1s backwards;
    letter-spacing: 0.4px;
    color: rgba($text-white, 0.95);
    font-weight: 500;
    margin: 6px 0 0 0;
  }

  .action-icon-btn {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    background: rgba(255, 255, 255, 0.15) !important;
    border: 2px solid rgba(255, 255, 255, 0.3) !important;
    backdrop-filter: blur(10px);
    border-radius: 12px !important;

    &:hover {
      background: rgba(255, 255, 255, 0.25) !important;
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
      transform: translateY(-2px);
    }

    &:active {
      transform: translateY(0);
    }
  }

  // ============================================
  // PAGE CONTENT
  // ============================================
  .page-content {
    background: transparent !important;
    padding: 20px 0 !important;
  }

  // ============================================
  // FORM FIELDS
  // ============================================
  .form-field {
    .v-input__control {
      .v-input__slot {
        background: white !important;
        border-radius: 12px !important;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06) !important;
        border: 1px solid $border-color !important;
      }
    }

    input {
      font-size: 15px !important;
      color: $text-off-black;

      &::placeholder {
        color: #999;
      }
    }

    .v-input__prepend-inner {
      color: $info-color !important;
      font-size: 18px !important;
    }

    &:hover .v-input__slot {
      border-color: $info-color !important;
    }

    &.v-input--is-focused .v-input__slot {
      box-shadow: 0 4px 16px rgba(0, 151, 215, 0.2) !important;
      border-color: $info-color !important;
    }
  }

  label {
    display: block;
    margin-bottom: 8px;

    h6 {
      font-size: 14px;
      font-weight: 700;
      color: $text-off-black;
      margin: 0;
      text-transform: uppercase;
      letter-spacing: 0.5px;

      .text-danger {
        color: #dc2626;
        font-size: 18px;
      }
    }
  }

  // ============================================
  // SUBMIT BUTTON
  // ============================================
  .submit-btn {
    background: linear-gradient(135deg, $success-color 0%, #16a34a 100%) !important;
    color: white !important;
    box-shadow: 0 8px 24px rgba(29, 185, 84, 0.3);
    transition: all 0.3s ease;
    font-weight: 700;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    border-radius: 12px !important;
    padding: 12px 48px !important;
    min-height: 52px !important;

    &:hover {
      box-shadow: 0 12px 32px rgba(29, 185, 84, 0.4);
      transform: translateY(-2px);
    }

    &:active {
      transform: translateY(0);
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }

    .v-icon {
      margin-right: 8px;
    }
  }

  // ============================================
  // RESPONSIVE DESIGN
  // ============================================
  @media (max-width: 960px) {
    padding: 20px 10px;

    .header-card {
      .v-row {
        flex-direction: column;
      }
    }

    .header-title {
      font-size: 28px !important;
    }

    .header-subtitle {
      font-size: 14px !important;
    }
  }

  @media (max-width: 600px) {
    padding: 15px 8px;

    .header-title {
      font-size: 22px !important;
    }

    .submit-btn {
      width: 100%;
    }
  }
}
</style>